// import { combineReducers } from "redux";
import { SET_MENU } from "./action-types";

const initState = {
  menu: "/",
};
function reducer(state = initState, action) {
  switch (action.type) {
    case SET_MENU:
      return { ...state, menu: action.data };
    default:
      return state;
  }
}

// export default combineReducers({ Mmenu });
export default reducer;
